export class AppStateManager {
    constructor(appStateService) {
        this.appStateService = appStateService;
    }
    deserialize(state) {
        return this.appStateService.deserialize(this.appStateService.serialize(state));
    }
}
